export default __webpack_public_path__ + "01dd6626000ee30490539c436c3daa4c.png";